export const about = {
  'seo.title': 'О нас — София и Елена | Эксперты по Нутрициологии и Косметологии',
  'seo.description': 'Познакомьтесь с Софией и Еленой — двумя экспертами-нутрициологами, работающими на стыке нутрициологии и косметологии.',
  'seo.keywords': 'София нутрициолог, Елена нутрициолог, детская нутрициология, гормональный фон, ЖКТ, метаболизм',

  'hero.title': 'Двое экспертов.\nОдин результат.',
  'hero.description': 'Мы не просто две подруги. Мы — консилиум, который работает на стыке нутрициологии и косметологии, чтобы ваше тело зазвучало красиво изнутри и снаружи.',

  'whyTwo.title': 'Почему двое экспертов — это ваш результат ×10',
  'whyTwo.doubleControl.title': 'Двойной контроль',
  'whyTwo.doubleControl.description': 'Пока один эксперт восстанавливает ваш гормональный фон и работу ЖКТ, второй — выстраивает ваш метаболизм, работает с дефицитами и заботится о том, чтобы ваша кожа сияла.',
  'whyTwo.deepExpertise.title': 'Глубокая экспертиза',
  'whyTwo.deepExpertise.description': 'Вы получаете глубокую экспертизу с двух сторон одновременно. Мы не лечим симптомы — мы пересобираем ваше здоровье «по кирпичикам».',
  'whyTwo.quote': 'Это не просто консультация. Это консилиум, где каждая деталь вашего здоровья рассматривается под микроскопом двух профессионалов.',

  'experts.title': 'Наши суперсилы',
  'experts.sofia.name': 'София',
  'experts.sofia.title': 'Нутрициолог с косметологическим бэкграундом',
  'experts.sofia.feature1': 'Эксперт по детскому питанию — знает, как сформировать здоровое пищевое поведение с колыбели',
  'experts.sofia.feature2': 'Работа с веганами и спортсменами — выстраивает питание для максимальной производительности',
  'experts.sofia.feature3': 'Знает, как сделать так, чтобы при похудении лицо выглядело на 5 лет моложе',
  'experts.sofia.imageAlt': 'София — нутрициолог с косметологическим бэкграундом',
  'experts.elena.name': 'Елена',
  'experts.elena.title': 'Нутрициолог-эксперт по ЖКТ и гормонам',
  'experts.elena.feature1': '«Алхимик» вашего организма — находит истинные причины воспалений и сбоев',
  'experts.elena.feature2': 'Эксперт по восстановлению гормонального фона и работы желудочно-кишечного тракта',
  'experts.elena.feature3': 'Работает с метаболизмом и дефицитами на глубинном уровне',
  'experts.elena.imageAlt': 'Елена — нутрициолог-эксперт по ЖКТ и гормонам',

  'philosophy.title': 'Бардак в голове = бардак в теле',
  'philosophy.belief': 'Мы не верим в диеты. Мы верим в знания.',
  'philosophy.description': 'Мы учим вас понимать сигналы своего тела, чтобы через 2 месяца вы стали сами себе лучшими нутрициологами. Это не временная диета — это новый образ жизни.',
  'philosophy.education.title': 'Образование',
  'philosophy.education.description': 'Мы даем вам знания, а не просто план питания',
  'philosophy.awareness.title': 'Осознанность',
  'philosophy.awareness.description': 'Учим слышать и понимать сигналы вашего тела',
  'philosophy.sustainability.title': 'Устойчивость',
  'philosophy.sustainability.description': 'Создаем привычки, которые останутся с вами навсегда',

  'cta.title': 'Готовы начать путь к себе?',
  'cta.description': 'Запишитесь на бесплатную диагностику, и мы покажем, как работает наш подход на практике.',
  'cta.primary': 'Выбрать программу',
  'cta.secondary': 'Узнать больше',
  'cta.primaryAria': 'Выбрать программу питания',
  'cta.secondaryAria': 'Узнать больше об услугах',
};